import { render, staticRenderFns } from "./footer-pubAg.vue?vue&type=template&id=a68e61ca&"
import script from "./footer-pubAg.vue?vue&type=script&lang=js&"
export * from "./footer-pubAg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports